export default "__VITE_PUBLIC_ASSET__0600b82b__"